export const VOUCHER_REQUEST_DEFAULT_VALUES = {
  expenseType: '',
  amountRequested: '',
  dateOfEvent: '',
  employeeNote: '',
  attachment: null,
};
